/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Form } from 'react-bootstrap';
import Input from './common/Input';
import Axios from 'axios';
import { useForm } from 'react-hook-form';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';

import { ToastContainer } from 'react-toastify';


const Settings = () => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);

    const { register, handleSubmit, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur'
    }
    );

    const [cuPass, setCuPass] = useState('');
    const [newPass, setNewPass] = useState('');
    const [conPass, setConPass] = useState('');
    const [passwordMatch, setPasswordMatch] = useState(true);
    const [message, setMessage] = useState('');
    const [owner, setOwner] = useState({});
    const [membershipFees, setMembershipFees] = useState(owner ? owner.membership_fees : 0);



    const fetchClient = () => {
        coreContext.fetchSelf(authContext.itemId);
    }

    const fetchOwner = () => {
        Axios.get('/self', { params: { itemId: authContext.ownerId } }).then(response => {
            setOwner(response.data.client);
            console.log('Owner data:', response.data.client);
            setMembershipFees(response.data.client.membership_fees);
        }).catch(err => { console.error(err); });
    }

    const changePasswordHandler = () => {
        authContext.verifyCurrentPassword(coreContext.client.item_email, cuPass, newPass);
    }


    useEffect(fetchClient, []);

    useEffect(fetchOwner, []);

    const onCheckCurrentPassword = (e) => {
        setCuPass(e.target.value);
        authContext.verifyCurrentPassword(coreContext.client.item_email, e.target.value, '');

    }

    const onNewPasswordChange = (e) => {
        setNewPass(e.target.value);
        onCheckNewPassword(e.target.value, conPass);
    }

    const onMembershipFeesChange = (e) => {
        setMembershipFees(e.target.value);
    }

    const updateMembershipFees = () => {
        coreContext.updateMembershipFees(authContext.ownerId, membershipFees);
    }

    const onConfirmPasswordChange = (e) => {
        setConPass(e.target.value);
        onCheckNewPassword(newPass, e.target.value);
    }

    const onCheckNewPassword = (np, cp) => {

        if (np !== cp) {
            setPasswordMatch(false);
            setMessage('Passwords do not match !');
        } else {
            setPasswordMatch(true);
            setMessage('');
        }
    }


    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Settings</Badge></h3></div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(changePasswordHandler)} noValidate>
                    <div className='row'>

                        <div className="col-md-2"><h5><Badge variant='danger'>Reset Password</Badge></h5></div>
                        <div className="col-md-3"> <Input label='Enter Current Password' name='cupass' value={cuPass} minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='password' placeholder='Enter Current Password' onBlur={onCheckCurrentPassword} />
                            <Input variant='danger' label={authContext.message} elementType='label' />
                        </div>
                        <div className="col-md-3"> <Input readOnly={!authContext.currPassVerified} label='Enter New Password' name='newpass' value={newPass} minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='password' placeholder='Enter New Password' onChange={onNewPasswordChange} /></div>
                        <div className="col-md-3"> <Input readOnly={!authContext.currPassVerified} label='Confirm New Password' name='conpass' value={conPass} minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='password' placeholder='Confirm New Password' onChange={onConfirmPasswordChange} />
                            <Input variant='danger' label={message} elementType='label' />
                        </div>
                        <div className="col-md-1" style={{ display: 'flex', alignItems: 'flex-end' }}>  <Input elementType='button' disabled={!authContext.currPassVerified || !passwordMatch} variant='primary' value="Update" /></div>


                    </div>
                </Form>
            </div>
            {authContext.item.smst_designation === 'Admin' || authContext.item.smst_designation === 'Moderator' ? <div className="card-body">
                <div className="row">
                    <div className="col-md-2"><h5><Badge variant='danger'>Vyavastha Shulk</Badge></h5></div>
                    <div className="col-md-2">
                        <Input label='Enter Vyavastha Shulk' name='membershipFees' value={membershipFees} minLength={2} maxLength={55} required={true} register={register} errors={errors} elementType='number' placeholder='Enter Vyavastha Shulk' onChange={onMembershipFeesChange} />
                    </div>

                    <div className="col-md-2" style={{ display: 'flex', alignItems: 'flex-end' }}><button onClick={updateMembershipFees} className="btn btn-primary">Update</button></div>
                    <div className="col-md-2" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <Input variant='success' label={coreContext.message} elementType='label' />
                    </div>
                </div>
            </div> : <div></div>}
        </div>
        <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={true}
            type='success'
        />
    </div>
    )
}

export { Settings }